import type { ReactNode } from 'react';
import { Icon } from './Icon';

/**
 * Seção que abre e fecha (acordeão), para tela com muita informação: o rótulo e um resumo curto ficam sempre à vista, o
 * conteúdo só quando a pessoa abre. `open` = começa aberta.
 */
export function Fold({ title, hint, open, children }: { title: ReactNode; hint?: ReactNode; open?: boolean; children: ReactNode }) {
  return (
    <details className="rr-fold" open={open}>
      <summary className="rr-fold__head">
        <span className="rr-label">{title}</span>
        {hint && <small className="rr-fold__hint">{hint}</small>}
        <Icon name="chevron-down" className="rr-fold__mark" />
      </summary>
      <div className="rr-fold__body">{children}</div>
    </details>
  );
}
